// import { Animated, Platform } from "@mrn/react-native";
import ScrollView from '@hfe/max-scrollview';
import { createElement, memo, useCallback, useRef, useEffect, forwardRef, useImperativeHandle } from '@max/max';
import { throttle } from './utils';
const isWeb = true;
const isMRN = false;
import { toPx } from '@max/leez-style-util';
// 最小拖拽距离，超过这个距离才认为是有效拖拽
const MIN_DRAG_DISTANCE = toPx(20);
const BounceScrollViewInner = forwardRef((props, ref) => {
    const { children, style, boundaryAxisOffset, contentContainerStyle, onScroll, onScrollBeginDrag, onScrollEndDrag, onMomentumScrollEnd, cardWidth = toPx(630 / 2), 
    // 618rpx卡片 + 12rpx间距
    autoScrollInterval = 0, totalCards = 0, ...restProps } = props;
    const scrollViewRef = useRef(null);
    const isInDragScroll = useRef(false);
    const lastScrollX = useRef(0);
    const dragStartX = useRef(0);
    const autoScrollTimerRef = useRef(null);
    const currentCardIndexRef = useRef(0);
    const hasUserInteractedRef = useRef(false); // 用户是否有过手势动作
    /**
     * 计算目标滚动位置
     * 根据当前滚动位置找到最近的卡片，然后根据滚动方向计算下一张或上一张卡片的起始位置
     */
    const calculateTargetPosition = useCallback((currentX, isScrollingLeft) => {
        // 找到最近的卡片索引（向下取整）
        const nearestCardIndex = Math.floor(currentX / cardWidth);
        // 根据滚动方向计算目标卡片索引
        // 往左滚（contentOffset.x增大）：滚动到下一张卡片
        // 往右滚（contentOffset.x减小）：滚动到上一张卡片
        const targetCardIndex = isScrollingLeft ? nearestCardIndex + 1 : Math.max(0, nearestCardIndex);
        // 计算目标位置
        const targetPosition = targetCardIndex * cardWidth;
        return targetPosition;
    }, [cardWidth]);
    /** 跳转至底部边界 */
    const scrollToBoundary = useCallback(throttle(() => {
        scrollViewRef.current?.scrollTo?.(isMRN ? {
            x: boundaryAxisOffset
        } : {
            x: boundaryAxisOffset,
            unitType: 'px'
        });
        // console.log('scrollToBoundary 触发，跳转至底部边界')
    }, 500), [scrollViewRef.current, boundaryAxisOffset]);
    // 处理横排滚动过程中的逻辑
    const handleHorizontalScroll = (event) => {
        const { contentOffset } = event.nativeEvent;
        // 更新上次滚动位置
        lastScrollX.current = contentOffset.x;
        console.log('更新上次滚动位置', lastScrollX.current);
        // 检查用户是否处于拖拽状态，如果是，则为拖拽滚动，允许拖出边界; 如果不是，则为惯性滚动，立刻回弹至边界
        if (!isInDragScroll.current) {
            // console.log('handleHorizontalScroll 惯性', contentOffset.x);
            // 如果惯性滚动超出了VoList的宽度，暂停惯性滚动
            if (contentOffset.x > boundaryAxisOffset) {
                // 不截流 IOS 滚不回去
                scrollToBoundary();
                // 重置惯性滚动状态
                isInDragScroll.current = false;
            }
            // 如果往左滚，拿到最近的那张卡片的起始位置，滚动到下一张卡片的起始位置，反之亦然
            // const targetX = calculateTargetPosition(contentOffset.x, isScrollingLeft);
            // if (isWeb){
            //   console.log('handleHorizontalScroll 触发，滚动到目标位置', targetX)
            //   scrollViewRef.current?.scrollTo?.(isMRN ? { x: targetX } : { x: targetX, unitType: 'px' });
            // }
            // throttle(() => {
            //   console.log('handleHorizontalScroll 触发，滚动到目标位置', targetX)
            //   scrollViewRef.current?.scrollTo?.(isMRN ? { x: targetX } : { x: targetX, unitType: 'px' });
            // }, 500);
        }
        onScroll?.(event);
    };
    // 处理用户松开手指时的逻辑（卡片吸附）
    const handleScrollSnapEnd = useCallback((event) => {
        isInDragScroll.current = false;
        const { contentOffset } = event.nativeEvent;
        // console.log('处理用户松开手指时的逻辑');
        // console.log(contentOffset.x);
        // 判断滚动方向
        const isScrollingLeft = contentOffset.x > dragStartX.current;
        // console.log('滚动方向:', isScrollingLeft ? '往左滚' : '往右滚');
        // 计算目标滚动位置
        let targetX = contentOffset.x;
        // 如果滚动超出边界，先回弹至边界
        if (contentOffset.x > boundaryAxisOffset) {
            targetX = boundaryAxisOffset;
        }
        else {
            // 未超出边界，则进行卡片吸附
            targetX = calculateTargetPosition(contentOffset.x, isScrollingLeft);
            if (true) {
                if (scrollViewRef.current && scrollViewRef.current._nativeNode && scrollViewRef.current._nativeNode.style) {
                    const originalOverflow = scrollViewRef.current?._nativeNode?.style?.overflow;
                    scrollViewRef.current._nativeNode.style.overflow = "hidden";
                    setTimeout(() => {
                        if (scrollViewRef.current)
                            scrollViewRef.current._nativeNode.style.overflow = originalOverflow;
                    }, 0);
                }
            }
        }
        // 滚动到目标位置
        scrollViewRef.current?.scrollTo?.(isMRN ? {
            x: targetX,
            animated: true
        } : {
            x: targetX,
            animated: true,
            unitType: 'px'
        });
        // console.log('handleScrollSnapEnd 触发，滚动到目标位置', targetX)
    }, [boundaryAxisOffset, calculateTargetPosition]);
    // 处理用户开始拖拽时的逻辑
    const handleScrollBegin = (event) => {
        isInDragScroll.current = true;
        dragStartX.current = event.nativeEvent.contentOffset.x;
        // 用户开始拖拽时，暂停自动滚动计时器
        // 但不立即标记为已交互，等待检测到有效拖拽距离后再标记
        if (autoScrollTimerRef.current) {
            clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    };
    /** 自动滚动到下一张卡片 */
    const autoScrollToNext = useCallback(() => {
        if (!scrollViewRef.current || totalCards <= 0)
            return;
        // 计算下一张卡片的索引
        let nextIndex = currentCardIndexRef.current + 1;
        // 如果超过最后一张，重新回到第一张
        if (nextIndex >= totalCards) {
            nextIndex = 0;
        }
        const targetX = nextIndex * cardWidth;
        scrollViewRef.current?.scrollTo?.(isMRN ? {
            x: targetX,
            animated: true
        } : {
            x: targetX,
            animated: true,
            unitType: 'px'
        });
        currentCardIndexRef.current = nextIndex;
        // 触发 onMomentumScrollEnd 回调，更新 currentGuideIndex
        onMomentumScrollEnd?.({
            nativeEvent: {
                contentOffset: {
                    x: targetX,
                    y: 0
                }
            }
        });
        // console.log('autoScroll to card', nextIndex);
    }, [cardWidth, totalCards, onMomentumScrollEnd]);
    /** 重置自动滚动计时器 */
    const resetAutoScroll = useCallback(() => {
        // 如果用户已有手势交互，则不启动自动滚动
        if (hasUserInteractedRef.current) {
            return;
        }
        // 清除旧的计时器
        if (autoScrollTimerRef.current) {
            clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
        // 如果设置了自动滚动间隔，则启动新的计时器
        if (autoScrollInterval > 0) {
            autoScrollTimerRef.current = setInterval(() => {
                autoScrollToNext();
            }, autoScrollInterval);
        }
    }, [autoScrollInterval, autoScrollToNext]);
    /**
     * 重置滚动视图状态
     * 用于当卡片列表数据变化时，将视图重置到初始状态
     */
    const reset = useCallback(() => {
        currentCardIndexRef.current = 0;
        hasUserInteractedRef.current = false;
        lastScrollX.current = 0;
        dragStartX.current = 0;
        // 清除自动滚动计时器
        if (autoScrollTimerRef.current) {
            clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
        // 滚动回到起始位置
        scrollViewRef.current?.scrollTo?.(isMRN ? {
            x: 0,
            animated: false
        } : {
            x: 0,
            animated: false,
            unitType: 'px'
        });
        // 重新启动自动滚动
        resetAutoScroll();
    }, [resetAutoScroll]);
    // 暴露 reset 方法给外部调用
    useImperativeHandle(ref, () => ({
        reset
    }), [reset]);
    /** 监听滚动结束，重置自动滚动计时器 */
    const handleScrollEndDrag = useCallback((event) => {
        // 先执行卡片吸附逻辑
        handleScrollSnapEnd(event);
        const contentOffset = event.nativeEvent.contentOffset.x;
        const dragDistance = Math.abs(contentOffset - dragStartX.current);
        // 检测用户是否进行了有效的拖拽
        // 只有拖拽距离超过最小距离阈值，才认为是有效拖拽
        if (dragDistance >= MIN_DRAG_DISTANCE) {
            // 有效拖拽，标记用户已交互，永久停止自动滚动
            hasUserInteractedRef.current = true;
            console.log('检测到有效拖拽距离:', dragDistance, '>=', MIN_DRAG_DISTANCE, '，停止自动滚动');
        }
        else {
            // 无效拖拽（点击或轻微滑动），只在未被标记为已交互时才继续自动滚动
            if (!hasUserInteractedRef.current) {
                console.log('拖拽距离不足:', dragDistance, '<', MIN_DRAG_DISTANCE, '，继续自动滚动');
                resetAutoScroll();
            }
        }
        // 更新当前卡片索引
        currentCardIndexRef.current = Math.round(contentOffset / cardWidth);
        // 触发原有的onScrollEndDrag回调
        onScrollEndDrag?.(event);
    }, [cardWidth, resetAutoScroll, onScrollEndDrag, handleScrollSnapEnd]);
    /** 组件挂载时启动自动滚动 */
    useEffect(() => {
        resetAutoScroll();
        return () => {
            if (autoScrollTimerRef.current) {
                clearInterval(autoScrollTimerRef.current);
                autoScrollTimerRef.current = null;
            }
        };
    }, [resetAutoScroll]);
    return <>
      <ScrollView {...restProps} ref={scrollViewRef} horizontal={true} showsHorizontalScrollIndicator={false} onScroll={handleHorizontalScroll} onScrollBeginDrag={handleScrollBegin} onScrollEndDrag={handleScrollEndDrag} scrollEventThrottle={32} 
    // 维持 IOS 和 安卓 两端的一致性
    mrnProps={{
        alwaysBounceHorizontal: false,
        bounces: false
    }} 
    // H5 兼容性处理：确保 onMomentumScrollEnd 非空，以触发 touch 事件绑定
    onMomentumScrollEnd={e => {
        console.log('onMomentumScrollEnd');
        const xOffset = e.nativeEvent.contentOffset.x;
        if (xOffset % cardWidth !== 0) {
            console.log('吸附位置');
            // handleScrollSnapEnd(e as any);
        }
        onMomentumScrollEnd?.(e);
    }}>
        {children}
      </ScrollView>
    </>;
});
const BounceScrollView = memo(BounceScrollViewInner);
export default BounceScrollView;
